module.exports = __webpack_public_path__ + "media/images/emblems/Sisseln-blason-be371f52cec0f5fd832509c5914bdf3a.png";